<template>
  <ul
    v-if="data"
    :class="{
      'mt-3 grid gap-6 md:grid-cols-2 lg:grid-cols-4': true,
    }"
  >
    <template
      v-for="card in data"
      :key="card._id"
    >
      <WhatsNewCard v-bind="card" />
    </template>
  </ul>
</template>

<script lang="ts" setup>
import type { WhatsNewQueryResult } from '~/sanity/types';
import { whatsNewQuery } from '../../../queries/components/Organisms/WhatsNew.query';
import WhatsNewCard from '~/components/Atoms/ManualCard/WhatsNewCard.vue';

const { data } = await useWwwSanityQueryNonNull<WhatsNewQueryResult>(whatsNewQuery, {
  type: 'whatIsNew',
});
</script>
